import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';

import useMidDropBoxV3 from './hooks/useMidDropBoxV3';

// Used for playlists list
function MidDropBoxV3({ active, accept, style, drop, containerRef = null, containerRefLvl = 0, maxSpeed = 10, threshold = 40 }) {
  const elementRef = useRef(null);
  let container = containerRef?.current;
  if (container) {
    if (containerRefLvl !== 0) {
      for (let i = 0; i < containerRefLvl; i++) {
        container = container.parentElement;
      }
    }
  }

  useEffect(() => {
    let container = containerRef?.current;
    if (container) {
      if (containerRefLvl !== 0) {
        for (let i = 0; i < containerRefLvl; i++) {
          container = container.parentElement;
        }
      }
    }
  }, [containerRef, containerRefLvl]);

  const [{ isOver, clientOffset }, refDrop] = useDrop({
    accept,
    drop,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      clientOffset: monitor.getClientOffset()
    })
  })

  useEffect(() => {
    if (!clientOffset) return
    let listContainer = containerRef.current
    const { top, bottom } = listContainer.getBoundingClientRect();
    if (clientOffset.y < top + threshold) {
      listContainer.scrollTop -= maxSpeed
    } else if (clientOffset.y > bottom - threshold) {
      listContainer.scrollTop += maxSpeed
    }
  }, [containerRef, maxSpeed, threshold, clientOffset])

  useEffect(() => {
    if (elementRef.current) {
      refDrop(elementRef.current);
    }
  }, [refDrop]);

  useMidDropBoxV3(active, isOver);

  return <div ref={elementRef} className={'mid-drop-box'} style={{...style}} />
}

MidDropBoxV3.propTypes = {
  active: PropTypes.any.isRequired,
  accept: PropTypes.any.isRequired,
  style: PropTypes.object,
  drop: PropTypes.func.isRequired
}

export default MidDropBoxV3;
